// src/components/formBuilder/Palette.jsx
import React from "react";
import { Box, Button, Stack, Tooltip, Divider } from "@mui/material";
import ButtonComponent from "../ui/ButtonComponent";

// Base field types
export const FIELD_TYPES = [
  { type: "text", label: "Text" },
  { type: "textarea", label: "Textarea" },
  { type: "number", label: "Number" },
  { type: "date", label: "Date" },
  { type: "select", label: "Select" },
  { type: "multiselect", label: "Multi-Select" },
  { type: "radio", label: "Radio Group" },
  { type: "checkbox", label: "Checkbox" },
  { type: "switch", label: "Switch" },
  { type: "slider", label: "Slider" },
];

// Special structural types
export const STRUCTURAL_TYPES = [
  {
    type: "section",
    label: "Section",
    tip: "Add a labeled section to group related fields together.",
  },
  {
    type: "divider",
    label: "Divider",
    tip: "Insert a horizontal divider to visually separate parts of the form.",
  },
  {
    type: "row",
    label: "Row Layout",
    tip: "Drag fields into Column A / B after creating the row.",
  },
  {
    type: "column",
    label: "Column Layout",
    tip: "Stack fields vertically inside a column layout.",
  },
];

export default function Palette({ onAdd, disabled = false }) {
  return (
    <Stack spacing={1}>
      {FIELD_TYPES.map((t) => (
        <Button
          key={t.type}
          variant="outlined"
          onClick={() => onAdd?.(t.type)}
          disabled={disabled}
          sx={{ justifyContent: "flex-start" }}
        >
          + {t.label}
        </Button>
      ))}

      <Divider sx={{ my: 2 }} />

      {STRUCTURAL_TYPES.map((lt) => (
        <Tooltip key={lt.type} title={lt.tip} placement="right">
          <span>
            <ButtonComponent
              label={`+ ${lt.label}`}
              onClick={() => onAdd?.(lt.type)}
              type="secondary"
              size="medium"
              disabled={disabled}
            />
          </span>
        </Tooltip>
      ))}

      <Box sx={{ mt: 2, color: "text.secondary", fontSize: 13 }}>
        Tip: Select a field on the canvas first to insert after it. Drag fields into Row Layout columns.
      </Box>
    </Stack>
  );
}